import { Component, OnInit } from "@angular/core";
import { TenantConfig } from "../../app.constants";
import { TenantConfigService } from "../../_services/http-api/tenant-config.service";

@Component({
  selector: "app-license-texts",
  templateUrl: "./license-texts.component.html",
  styleUrls: ["./license-texts.component.scss"],
  standalone: false
})
export class LicenseTextsComponent implements OnInit {
  serialNumberLabel = TenantConfig.DefaultConfigurationValues.LabelOfSerialNumber;

  constructor(private tenantConfigService: TenantConfigService) {}

  ngOnInit(): void {
    this.setConfig();
  }

  setConfig() {
    const configs = this.tenantConfigService.tenantConfig;
    if (configs) {
      const snLabelConfig = configs.find((_) => _.key === TenantConfig.LabelOfSerialNumber.KEY);
      if (snLabelConfig) {
        this.serialNumberLabel = snLabelConfig.value as string;
      }
    }
  }
}
